import { render, staticRenderFns } from "./ConfigView.vue?vue&type=template&id=4f896b3a&scoped=true"
import script from "./ConfigView.vue?vue&type=script&lang=js"
export * from "./ConfigView.vue?vue&type=script&lang=js"
import style0 from "./ConfigView.vue?vue&type=style&index=0&id=4f896b3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f896b3a",
  null
  
)

export default component.exports